<template>
  <div class="newsList">
    <div style="display: flex;align-items: center;justify-content: space-between;">
      <p class="pageTitle">{{isEdit?'修改':'添加'}}新闻</p>
      <Button class="greenBtn" shape="circle" to="/admin_system/news/list">返回列表</Button>
    </div>
    <div class="pageContent">
      <Form :model="form" :rules="rules" ref="newsForm" label-position="left" :label-width="100">
        <Row :gutter="20">
          <Col span="14">
            <FormItem label="新闻标题" prop="title">
              <Input type="textarea" v-model="form.title" clearable></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="14">
            <FormItem label="简述" prop="title">
              <Input type="textarea" v-model="form.subTitle" clearable></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="20">
          <Col span="7">
            <FormItem label="新闻分类" prop="type">
              <Select v-model="form.type" clearable>
                <Option value="新闻动态">新闻动态</Option>
                <Option value="通知公告">通知公告</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Col span="24">
          <FormItem label="是否外链">
            <RadioGroup v-model="form.isUrl">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </FormItem>
        </Col>
        <Col span="14" v-if="form.isUrl==1">
          <FormItem label="外部链接" prop="content">
            <Input v-model="form.content" clearable></Input>
          </FormItem>
        </Col>
        <Col span="24" v-if="form.isUrl==0">
          <FormItem label="新闻内容" prop="content">
            <Editor :content="form.content" @updateContent="updateContent"/>
          </FormItem>
        </Col>
        <Row :gutter="20">
          <Col span="24">
            <FormItem label="是否置顶">
              <RadioGroup v-model="form.isTop">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="热点推荐">
              <RadioGroup v-model="form.isHot">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="显示/隐藏">
              <RadioGroup v-model="form.isHide">
                <Radio :label="0">显示</Radio>
                <Radio :label="1">隐藏</Radio>
              </RadioGroup>
            </FormItem>
          </Col>
        </Row>
        <div class="btnWrap">
          <Button class="defaultBtn" type="primary" :loading="submitting" @click="submit">提交</Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
  import Editor from "@/components/Editor.vue";
  import NewsService from "@/api/news";

  export default {
    components: {
      Editor
    },
    data() {
      return {
        form: {isHide: 0, content: "", type: '新闻动态', isTop: 0, cover: "", isHot: 0, isUrl: 1},
        rules: {
          title: [
            {required: true, message: "请输入新闻标题", trigger: "blur,change"}
          ],
          type: [
            {required: true, message: "请选择新闻分类", trigger: "blur,change"}
          ],
          content: [
            {required: true, message: "请输入新闻内容", trigger: "blur,change"}
          ]
        },

        token: this.$store.getters.token,

        submitting: false,
        isEdit: false
      };
    },
    mounted() {
      let id = this.$route.query.id;
      if (id) {
        this.isEdit = true;

        this.getInfo(id);
      }
    },
    methods: {
      // 更新新闻内容
      updateContent(data) {
        this.form.content = data;
        this.$refs.newsForm.validateField("content");
      },
      // 提交
      submit() {
        this.$refs.newsForm.validate(valid => {
          if (valid) {
            this.submitting = true;
            NewsService.saveNews(this.form)
                .then(res => {
                  if (res.errorNo == 0) {
                    let text = "",
                        _this = this;
                    if (this.form.id) {
                      text = "新闻修改成功！点击确认按钮将跳转到新闻列表页。";
                    } else {
                      text = "新闻发布成功！点击确认按钮将跳转到新闻列表页。";
                    }
                    this.$Modal.confirm({
                      title: "提示",
                      content: text,
                      onOk: function () {
                        _this.$router.push("/admin_system/news/list");
                      },
                      onCancel: function () {
                        if (!_this.form.id) {
                          _this.$refs.newsForm.resetFields();
                        }
                      }
                    });
                  } else {
                    this.$Message.error(res.errorMessage);
                  }
                  this.submitting = false;
                })
                .catch(() => {
                  this.$Message.error("连接服务器失败，请稍后再试");
                  this.submitting = false;
                });
          } else {
            this.$Message.error("信息未正确填写完整");
          }
        });
      },
      // 获取列表
      getInfo(id) {
        NewsService.getNewsInfo(id)
            .then(res => {
              if (res.errorNo == 0) {
                this.form = res.data;
              } else {
                this.$Message.error(res.errorMessage);
              }
            })
            .catch((error) => {
              console.table(error)
              this.$Message.error("连接服务器失败，请稍后再试");
            });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .newsList {
    position: relative;

    .uploadBtn {
      background: #277a44;
      color: #ffffff;
      margin-right: 10px;
    }

    .imgItem {
      position: relative;
      top: 0;
      width: 80px;
      height: 80px;
      display: inline-block;
      margin: 10px 10px 0 0;
      background: rgba($color: #000000, $alpha: 0.1);
      vertical-align: top;

      .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }

    .btnWrap {
      text-align: center;
      padding: 30px 0;
    }
  }
</style>